import React from "react";
import "./ActivityInfo.scss";

export default function ActivityInfo({size}) {
  return <div className={`c-activity-info ${size}`}>
    <div className="c-activity-info-inner">
      Unsere Gutscheine sind 3 Jahre gültig und danach kostenlos verlängerbar. Sollte ein Erlebnis momentan nicht durchführbar sein, ist das also kein Problem.
    </div>
  </div>
}